import { createStore } from 'vuex'
import {getRequest} from "@/assets/js/common";

const store = createStore({
    state: {
        user: sessionStorage.getItem('user') || null,
    },
    mutations: {
        getUserInfo(state, user) {
            state.user = user;
        },
    },
    actions: {
        async getUserInfo({ commit }) {
            let token = sessionStorage.getItem('token');
            if (token) {
                await getRequest('/user/getUserInfo')
                    .then(res => {
                        if (res.code && res.data.id) {
                            let user= JSON.stringify(res.data);
                            sessionStorage.setItem('user',user)
                            commit('getUserInfo', user);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching user info:', error);
                    });
            } else {
                sessionStorage.removeItem('user')
                commit('getUserInfo', null);
            }
        }
    },
    getters: {
    }
})

export default store
